import { Suspense, lazy, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "hardcover-ui/components/Modal";
import Container from "hardcover-ui/components/Container";
import { useIsLoginVisible } from "store/ui/uiSelector";
import { uiActions } from "store/ui/uiSlice";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { DefaultPageType } from "types/DefaultPageType";
import { usePage } from "@inertiajs/react";

const JoinOrLoginForm = lazy(() => import("components/join/JoinOrLoginForm"));

export default function LoginModal() {
  const isLoggedIn = useIsLoggedIn();
  const dispatch = useDispatch();
  const showModalTab = useIsLoginVisible();
  const { pathName } = usePage<DefaultPageType>().props;
  const [initialPath] = useState(pathName);

  const closeModal = useCallback(() => {
    dispatch(uiActions.toggleLoginVisible(false));
  }, [showModalTab]);

  // Close the modal if they navigate to a different page
  useEffect(() => {
    if (initialPath !== pathName) {
      dispatch(uiActions.toggleLoginVisible(false));
    }
  }, [pathName]);

  if (isLoggedIn) {
    return <></>;
  }

  return (
    <Modal
      onClose={closeModal}
      open={showModalTab !== false}
      size="xs"
      position="center"
      disablePopState
      modalTitle="Login"
    >
      <Container size="xs" variant="primary" className="px-4 md:px-0 py-4">
        {showModalTab && (
          <Suspense fallback={<LoadingSpinner size="lg" variant="layout" />}>
            <JoinOrLoginForm onClose={closeModal} tab={showModalTab} />
          </Suspense>
        )}
      </Container>
    </Modal>
  );
}
